import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { isFunction, partial } from 'lodash-es'

import { generateImageUrl, getRgbaTransparency, rgbaToHex } from '../../utils'
import TooltipComponent from '../TooltipComponent/TooltipComponent'
import ConditionWrapComponent from '../ConditionWrapComponent/ConditionWrapComponent'
import ImageComponent from '../ImageComponent/ImageComponent'

import './IconComponent.scss'

const renderTooltip = (tooltip, tooltipOptions, icon) => (
  <TooltipComponent
    title={tooltip}
    className="icon-tooltip"
    {...tooltipOptions}
  >
    {icon}
  </TooltipComponent>
)

const handleKeyDown = (onClick, e) => {
  if (e.keyCode === 13 || e.keyCode === 32) {
    onClick(e)
  }
}

const IconComponent = (props) => {
  const {
    name,
    size,
    className,
    onClick,
    tooltip,
    displayBoxOnHover,
    tooltipOptions,
    disabled,
    invertedHover,
    wrapperStyle,
    color,
    ariaLabel,
  } = props
  let { color: newColor, style: newStyle } = props

  if (color && color.match(/^rgb/)) {
    newColor = rgbaToHex(color, true)
    newStyle = { opacity: getRgbaTransparency(props.color), ...newStyle }
  }

  const src = generateImageUrl({ name, color: newColor, size })
  const isIconClickable = isFunction(onClick) && !disabled
  const classNames = classnames('icon-component', className, {
    'icon-clickable': isFunction(onClick) && !disabled,
    'inverted-hover': invertedHover,
    'hover-box': displayBoxOnHover,
    'is-disabled': disabled,
  })

  return (
    <ConditionWrapComponent
      condition={!!tooltip}
      wrap={partial(renderTooltip, tooltip, tooltipOptions)}
    >
      <span
        aria-hidden
        className={classNames}
        {...(isIconClickable && {
          role: 'button',
          tabIndex: '0',
          onClick,
          onKeyDown: partial(handleKeyDown, onClick),
          'aria-label': ariaLabel || tooltip,
        })}
        style={wrapperStyle}
      >
        <ImageComponent
          src={src}
          alt={`${name}-icon`}
          loading="eager"
          style={newStyle}
        />
      </span>
    </ConditionWrapComponent>
  )
}

IconComponent.propTypes = {
  name: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.arrayOf(PropTypes.number),
  className: PropTypes.string,
  onClick: PropTypes.func,
  invertedHover: PropTypes.bool,
  tooltip: PropTypes.string,
  tooltipOptions: PropTypes.object,
  displayBoxOnHover: PropTypes.bool,
  disabled: PropTypes.bool,
  style: PropTypes.object,
  wrapperStyle: PropTypes.object,
  ariaLabel: PropTypes.string,
}

export default IconComponent
